/**
 * @generated SignedSource<<af611c4f618ba0903830e6c9df5c44e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateAsanaVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createAsanaVerificationKeyMutation$variables = {
  input: CreateAsanaVerificationKeyInput;
};
export type createAsanaVerificationKeyMutation$data = {
  readonly createAsanaVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createAsanaVerificationKeyMutation = {
  variables: createAsanaVerificationKeyMutation$variables;
  response: createAsanaVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateAsanaVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createAsanaVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createAsanaVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createAsanaVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3d3e7f33191f4c75cc2cce12425ec35d",
    "id": null,
    "metadata": {},
    "name": "createAsanaVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createAsanaVerificationKeyMutation(\n  $input: CreateAsanaVerificationKeyInput!\n) {\n  createAsanaVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ef17cda5c78ced2cf9d78f8d1b84fe7";

export default node;
